/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Dialog_Cancel_BtnInputs */

const vi_sl_detail_dialog_cancel_btn = /** @type {(inputs: Sl_Detail_Dialog_Cancel_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hủy`)
};

/**

* @param {Sl_Detail_Dialog_Cancel_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_dialog_cancel_btn = /** @type {((inputs?: Sl_Detail_Dialog_Cancel_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Dialog_Cancel_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_dialog_cancel_btn(inputs)
});